import { render } from "./UsersAdministrationView.vue?vue&type=template&id=5dc02dba&scoped=true"
import script from "./UsersAdministrationView.vue?vue&type=script&lang=js"
export * from "./UsersAdministrationView.vue?vue&type=script&lang=js"

import "./UsersAdministrationView.vue?vue&type=style&index=0&id=5dc02dba&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc02dba"]])

export default __exports__